/** MongoDB ObjectId (24 hex chars) used for admin product routes. */
const OBJECT_ID_RE = /^[a-f0-9]{24}$/i;

export function isMongoObjectId(value) {
  if (value == null) return false;
  const s = String(value).trim();
  return OBJECT_ID_RE.test(s);
}

/** Prefer `_id` / `id` over business `productId` (SKU-style ids break PUT /api/admin/products/:id). */
export function getMongoProductId(entity) {
  if (!entity) return null;
  const candidates = [entity._id, entity.id, entity.productId];
  for (const c of candidates) {
    if (c == null) continue;
    if (typeof c === 'object' && c.$oid) {
      const oid = String(c.$oid).trim();
      if (isMongoObjectId(oid)) return oid;
    }
    if (isMongoObjectId(c)) return String(c).trim();
  }
  return null;
}

/** Resolve Mongo id from create/upload API response shapes. */
export function extractCreatedProductId(result) {
  if (!result) return null;
  const rows = [
    result,
    result.data,
    result.data?.product,
    result.product,
  ].filter((r) => r && typeof r === 'object');
  for (const row of rows) {
    const id = getMongoProductId(row);
    if (id) return id;
  }
  return null;
}
